console.clear();

var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var renderHistogram = require("./renderHistogram");
var renderWidget = require("./renderWidget");

// Global vars
var pymChild = null;
var skipLabels = ["date", "notes", "values", "total", "Total"];

// Initialize the graphic.
var onWindowLoaded = function() {
  var houseData = window.DATA.filter(d => d.chamber == "H");
  var house = calculateData(houseData);
  var senateData = window.DATA.filter(d => d.chamber == "S");
  var senate = calculateData(senateData);

  var totals = calculateTotals(window.DATA);

  formatData(house);
  formatData(senate);

  var quarantines = [house, senate].map(ch => ch.map(d => d.Total));
  var max = Math.max(...quarantines.flat());

  var calculated = { house, senate, max };
  render(calculated, totals);

  window.addEventListener("resize", () => render(calculated, totals));

  pym.then(child => {
    pymChild = child;
    child.sendHeight();

    // pymChild.onMessage("on-screen", function(bucket) {
    //   ANALYTICS.trackEvent("on-screen", bucket);
    // });
    //
    // pymChild.onMessage("scroll-depth", function(data) {
    //   data = JSON.parse(data);
    //   ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
    // });
  });
};

var calculateTotals = function(data) {
  var totals = {
    houseQuarantine: 0,
    housePositive: 0,
    senateQuarantine: 0,
    senatePositive: 0
  }

  var houseMembers = [];
  var senateMembers = [];

  data.forEach(function(d) {
    if (d.quarantine_start) {
      if (d.chamber == "H") {
        if (!houseMembers.includes(d.member)) {
          totals.houseQuarantine += 1;
          houseMembers.push(d.member)
        }
        if (d.positive) {
          totals.housePositive += 1;
        }
      } else if (d.chamber == "S") {
        if (!senateMembers.includes(d.member)) {
          totals.senateQuarantine += 1;
          senateMembers.push(d.member)
        }
        if (d.positive) {
          totals.senatePositive += 1;
        }
      }
    }
  });

  return totals;
};

var calculateData = function(data) {
  var calculated = [];
  // console.log(data)
  var start = new Date();
  var end = new Date(LABELS.last_updated);

  data.forEach(function(d) {
    var date = new Date(d.quarantine_start);
    if (date && date < start) start = date;
  })

  var current = start;
  while (current <= end) {
    var dateObj = {
      date: current.toLocaleDateString('en-US'),
      "Tested or presumed positive": 0,
      "Precautionary quarantine": 0,
      Total: 0
      // Released: 0,
      // Recovered: 0
    };

    data.forEach(function(d) {
      var tomorrow = new Date(LABELS.last_updated);
      tomorrow = new Date(tomorrow.setDate(tomorrow.getDate() + 1));

      // var positiveStart = d.positive_start ? new Date(d.positive_start) : d.positive_public ? new Date(d.positive_public) : null;

      var positive = d.positive;
      var quarantineStart = d.quarantine_start ? new Date(d.quarantine_start) : null;
      // var quarantineEnd = d.quarantine_end ? new Date(d.quarantine_end) : tomorrow;
      var quarantineEnd = null;
      if (d.quarantine_end == "n/a" || !d.quarantine_end) {
        quarantineEnd = tomorrow;
      } else {
        quarantineEnd = new Date(d.quarantine_end);
      }

      // console.log(d.member, "positiveStart", positiveStart, "quarantineStart", quarantineStart, "quarantineEnd", quarantineEnd)

      if (quarantineStart && quarantineStart <= current && quarantineEnd > current) {
        if (positive) {
          dateObj["Tested or presumed positive"] += 1;
          dateObj.Total += 1;
        }
        if (!positive) {
          dateObj["Precautionary quarantine"] += 1;
          dateObj.Total += 1;
        }
      }

      // if (positiveStart && positiveStart <= current && quarantineEnd > current) {
      //   dateObj["Tested or presumed positive"] += 1;
      //   dateObj.Total += 1;
      // }
      // if (!positiveStart && quarantineStart && quarantineStart <= current && quarantineEnd > current) {
      //   dateObj.Quarantined += 1;
      //   dateObj.Total += 1;
      // }
      // if (positiveStart && quarantineEnd <= current) {
      //   dateObj.Recovered += 1;
      // }
      // if (!positiveStart && quarantineStart && quarantineEnd <= current) {
      //   dateObj.Released += 1;
      // }
    });

    calculated.push(dateObj);

    var next = current.setDate(current.getDate() + 1);
    current = new Date(next);
  }

  return calculated;
};

// Format graphic data for processing by D3.
var formatData = function(data) {
  // console.log(data)
  data.forEach(function(d) {
    var y0 = 0;

    d.values = [];
    d.total = 0;

    for (var key in d) {
      if (skipLabels.indexOf(key) > -1) {
        continue;
      }

      var y1 = y0 + d[key];
      d.total += d[key];

      d.values.push({
        name: key,
        y0: y0,
        y1: y1,
        val: d[key]
      });

      y0 = y1;
    }
  });
  return data;
};

// Render the graphic(s). Called by pym with the container width.
var render = function(calculated, totals) {
  var { max } = calculated;

  var container = "#stacked-column-chart";
  var element = document.querySelector(container);

  // Render the chart!
  if (element) {
    var fallback = element.querySelector(".fallback");
    if (fallback) fallback.remove();

    // var width = element.offsetWidth;
    renderHistogram({
      chamber: "senate",
      container: element.querySelector(".senate-chart"),
      width: element.querySelector(".senate-chart").offsetWidth,
      data: calculated.senate,
      max
    });
    renderHistogram({
      chamber: "house",
      container: element.querySelector(".house-chart"),
      width: element.querySelector(".house-chart").offsetWidth,
      data: calculated.house,
      max
    });
  } else if (document.querySelector("#tracker-widget")) {
    renderWidget(totals);
  }

  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
};

// Initially load the graphic
//(NB: Use window.load to ensure all images have loaded)
window.onload = onWindowLoaded;
